import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { font } from '../../styles';
import { displayNullable } from '../../types';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
const CaptionRowStyled = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});
const ContentStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'captionTop',
})(({ theme, captionTop }) => ({
    order: captionTop ? 1 : 'unset',
    color: theme.palette.primary.dark,
    lineHeight: font.lineHeight.xs,
    display: 'grid',
}));
const IconStyled = styled(Icon)(({ theme }) => ({
    fontSize: font.size.l,
    marginRight: theme.spacing(1),
}));
const IconRowStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    color: theme.palette.primary.dark,
}));
const ValueStyled = styled(Typography)({
    lineHeight: font.lineHeight.xs,
});
const getDataValues = (captionTop, data, variant, className, noWrap = true) => (_jsx(ContentStyled, { captionTop: captionTop, children: data.map((dataEntry, i) => (_jsx(ValueStyled, { color: "inherit", variant: variant ? variant : 'body2', className: className, noWrap: noWrap, children: displayNullable(dataEntry) }, i))) }));
export const DataSet = ({ data, caption, captionTop, icon, variant, className, tooltip, title, noWrap, }) => {
    if (caption) {
        return (_jsxs(CaptionRowStyled, { children: [getDataValues(captionTop, data, variant, className, noWrap), _jsxs("span", { children: [_jsx(Typography, { variant: "caption", children: caption }), tooltip && _jsx(Tooltip, { ...tooltip })] })] }));
    }
    if (icon) {
        return (_jsxs(IconRowStyled, { children: [_jsx(IconStyled, { variant: icon, title: title }), getDataValues(captionTop, data, variant, className, noWrap), tooltip && _jsx(Tooltip, { ...tooltip })] }));
    }
    return (_jsxs("div", { children: [getDataValues(captionTop, data, variant, className, noWrap), tooltip && _jsx(Tooltip, { ...tooltip })] }));
};
